import { Pipe, PipeTransform } from '@angular/core';


// Para utilizar este pipe, deve-se somente importar o share.module no modulo que será utilizado. Não importe este pipe, pois ele já é exportado no share module
// Ex: filtro por discriminator: { r.cobrancas | count:'Passagem'} -> conta o numero de objetos que tem o atributo discriminator = 'Passagem'
// Ex: somente contar: { r.cobrancas | count } -> conta o numero de objetos

@Pipe({
  name: 'count'
})
export class CountPipe implements PipeTransform {
  transform(value: any[], discriminator:string): any {
    return value.filter(item => discriminator ? item.discriminator === discriminator : item).length
  }
}
